import { FormCheckboxField, lt, useFieldDependency } from '@mews/framework';
import { usePosMicrosConfigurationContext } from '../../contexts/posMicrosConfigurationContext';
import { FieldNames } from '../fieldNames';
import { MicrosConfigurationFormSchema } from '../formProps';
import { useDirtyFormState } from './useDirtyFormState';

export const MultiDepartmentField = () => {
    const isFormDirty = useDirtyFormState();
    const { setPosMicrosConfigurationState } = usePosMicrosConfigurationContext();

    const { dependencyValue } = useFieldDependency<
        MicrosConfigurationFormSchema,
        FieldNames.detailedBillingConfigurationUseDetailedBilling
    >({
        name: FieldNames.detailedBillingConfigurationUseMultiDepartment,
        dependency: FieldNames.detailedBillingConfigurationUseDetailedBilling,
        setInitialValueDisabled: !isFormDirty,
    });

    const handleOnChange = (checked: boolean) => {
        setPosMicrosConfigurationState((prevState) => ({
            ...prevState,
            useMultiDepartment: checked,
        }));
    };

    return (
        <FormCheckboxField
            name={FieldNames.detailedBillingConfigurationUseMultiDepartment}
            disabled={!dependencyValue}
            onChange={(event, checked) => {
                handleOnChange(checked);
            }}
        >
            {lt('MultiRevenueCategories')}
        </FormCheckboxField>
    );
};
